<div class="user-profile stake-setting">
    <div class="col-md-12">
        <div class="card-header">
            <h4 class="mb-0 text-uppercase"><i class="mdi mdi-account"></i>Stake Setting</h4>
        </div>

        <div class="col-md-12">
            <!-- Set Button Value start -->
            <div class="market_section">
                <div class="row mx-0 align-items-center justify-content-center">
                    <div class="col-xl-5 col-lg-12 col-md-12 col-12 px-0">
                        <div class="button-value-table">
                            <div>
                                <table class="table button-value">
                                    <thead>
                                        <tr>
                                            <th>Price Label</th>
                                            <th>Price Value</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let arr of stArr;let i=index;">
                                            <td><input [(ngModel)]="stacks['stake_amount_'+ (i+1)]" type="text" readonly /></td>
                                            <td><input name="stackVal{{i}}" [(ngModel)]="stacks['stake_amount_'+ (i+1)]" type="number"
                                                (change)="stacks['stake_name_'+ (i+1)] = stacks['stake_amount_'+ (i+1)]+'';" /></td>
                                        </tr>
                                        <tr>
                                            <td colspan="2">
                                                <div class="text-right">
                                                    <button type="button" class="btn btn-dark btn-block" (click)="setBtnVal()">Submit</button>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <app-loader class="full-overlay" *ngIf="isLoading"></app-loader>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <!-- Set Button Value start -->
        </div>

    </div>
</div>